import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/operadores/operators";
import operators from "../../models/operadores/operators";
import rulesLiquidations from "@/store/modelosDeLiquidacion/rulesLiquidation";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    operators: [],
    tablas: [],
    open: false,
    mode: "",
    new: [],
    newAudit: {},
    edit: {},
    editRelation: {},
    itemDelete: null,
    openDelete: false,
    showCard: false,
    showTable: false,
    openFormRelation: false,
    modeFormRelation: "",
    email: "",
    idOper: "",
    sendMail: false,
  },

  mutations: {
    setIdOper(state, data) {
      state.idOper = data;
    },
    setPass(state, data) {
      state.pass = data;
    },
    setSendMail(state, data) {
      state.sendMail = data;
    },
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setOperators(state, data) {
      state.operators = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setTablas(state, data) {
      state.tablas = data;
    },
    setShowCard(state, data) {
      state.showCard = data;
    },
    setShowTable(state, data) {
      state.showTable = data;
    },
    setOpenFormRelation(state, data) {
      state.openFormRelation = data;
    },
    setModeFormRelation(state, data) {
      state.modeFormRelation = data;
    },
    setEditRelation(state, data) {
      state.editRelation = data;
    },
    setNewAudit(state, data) {
      state.newAudit = data;
    },
  },
  actions: {
    async getOperators(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getOperators();
          state.commit("setOperators", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getOperatorId({ state, commit }, id) {
      try {
        const data = await state.service.getOpertatorId(id);
        const audit = await state.service.getOpertatorIdAudit(id);
        let tablas = await state.service.getOperatorsTablas();
        commit("setTablas", tablas);
        data.audit = audit;
        commit("setEdit", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async add(state) {
      try {
        const response = await state.state.service.addOperator(state.state.new);
        const newItem = operators.fromJson(response.data);
        const updated = [newItem, ...state.state.operators];
        state.commit("setOperators", updated);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteOperator(state.state.itemDelete)
            .then(() => {
              let options = state.state.operators;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setOperators", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editOperator(state.state.editRelation)
            .then(async () => {
              const data = await state.state.service.getOperators();
              state.commit("setOperators", data);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async addEmployeeToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const payload = {
            operId: state.state.new[0].operId,
            emps: state.state.new.map((emp) => emp.empId),
          };

          await state.state.service.addEmployeeToOperator(payload);

          if (!state.state.edit.empleados) {
            state.state.edit.empleados = [];
          }

          for (let i = 0; i < state.state.new.length; i++) {
            state.state.edit.empleados.unshift(state.state.new[i]);
          }

          state.commit("setEdit", { ...state.state.edit });
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteEmployeeToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteEmployeeToOperator(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.empleados;

              options = options.filter((option) => {
                return option.empId !== state.state.itemDelete.empId;
              });

              let edit = { ...state.state.edit };
              edit.empleados = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    //Operador-Grupo
    async addGroupToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const payload = {
            operId: state.state.new[0].operId,
            grupos: state.state.new.map((group) => group.groupId),
          };

          await state.state.service.addGroupToOperator(payload);

          if (!state.state.edit.grupos) {
            state.state.edit.grupos = [];
          }
          for (let i = 0; i < state.state.new.length; i++) {
            state.state.edit.grupos.unshift(state.state.new[i]);
          }

          state.commit("setEdit", { ...state.state.edit });
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteGroupToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteGroupToOperator(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.grupos.filter((option) => {
                const grupoId = option.groupId || option.grupoId;
                return grupoId !== state.state.itemDelete.grupoId;
              });

              let edit = { ...state.state.edit, grupos: options };
              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //Operadores-Unidades de Negocios
    async addBusinessUnitsToOperator(state) {
      try {
        const response = await state.state.service.addBusinessUnitsToOperator(
          state.state.new
        );
        const newItem = response.data;

        const formattedNew = {
          ...newItem,
          nombre: state.state.new.name,
          def: state.state.new.def ? "S" : "",
          fecHasta: moment.utc(newItem.fecHasta).format("YYYY-MM-DD"),
        };

        if (!state.state.edit.unnegocios) {
          const updatedEdit = {
            ...state.state.edit,
            unnegocios: [formattedNew],
          };
          state.commit("setEdit", updatedEdit);
        } else {
          const updatedEdit = {
            ...state.state.edit,
            unnegocios: [...state.state.edit.unnegocios, formattedNew],
          };
          state.commit("setEdit", updatedEdit);
        }

        return true;
      } catch (error) {
        throw error;
      }
    },
    async editBusinessUnitsToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editBusinessUnitsToOperator(state.state.editRelation)
            .then(async () => {
              const operatorId = state.state.edit.operId;
              const operatorData = await state.state.service.getOpertatorId(
                operatorId
              );
              state.commit("setEdit", operatorData);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteBusinessUnitsToOperator(state) {
      try {
        await state.state.service.deleteBusinessUnitsToOperator(
          state.state.itemDelete
        );
        const options = state.state.edit.unnegocios.filter(
          (option) => option.unNegocioId !== state.state.itemDelete.id
        );

        state.commit("setEdit", { ...state.state.edit, unnegocios: options });

        return true;
      } catch (error) {
        throw error;
      }
    },

    //Operador-Rol
    async addRoleToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addRoleToOperator(
            state.state.new
          );
          const newItem = state.state.new;

          const updatedRoles = state.state.edit.roles
            ? [...state.state.edit.roles, newItem]
            : [newItem];

          const updatedEdit = {
            ...state.state.edit,
            roles: updatedRoles,
          };

          state.commit("setEdit", updatedEdit);

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteRoleToOperator(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRoleToOperator(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.roles;
              options = options.filter((option) => {
                return option.rolId !== state.state.itemDelete.rolId;
              });

              let edit = { ...state.state.edit };
              edit.roles = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editEmployee(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editEmployeeToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.empleados;
              options = options.map((option) => {
                if (option.empId !== Number(item.id)) {
                  return option;
                }
                const nameEmployee =
                  this.$store.state.employees.employees.filter(
                    (employee) => employee.empId === Number(item.id)
                  );

                const updatedItem = {
                  empId: Number(item.id),
                  nombre: nameEmployee[0].lastName + " " + nameEmployee[0].name,
                  fecDesde: item.formItems.dateStartInput,
                  fecHasta: item.formItems.dateEndInput,
                };

                return updatedItem;
              });

              let edit = { ...state.state.edit };
              edit.empleados = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //grupos

    async addGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addGroupToLiquidation(
            state.state.new
          );
          const newItem = response.data;
          const nameGroup = this.$store.state.changeGroup.group.item.filter(
            (item) => item.groupId === newItem.grupoId
          );

          if (nameGroup.length > 0) {
            newItem.nombre = nameGroup[0].name;
          }

          if (!state.state.edit.grupos) {
            const updatedEdit = {
              ...state.state.edit,
              grupos: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              grupos: [...state.state.edit.grupos, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteGroupToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.grupos;
              options = options.filter((option) => {
                return option.grupoId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.grupos = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editGroup(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editGroupToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.grupos;

              options = options.map((option) => {
                if (option.grupoId !== Number(item.id)) {
                  return option;
                }
                item = {
                  fecDesde: item.itemsForm.dateStartInput,
                  fecHasta: item.itemsForm.dateEndInput,
                  grupoId: item.id,
                  nombre: item.nombre,
                };
                return item;
              });

              let edit = { ...state.state.edit };
              edit.grupos = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //firmas

    async addFirm(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.addFirmToLiquidation(
            state.state.new
          );
          const newItem = response.data;

          const nameOperator = operators.state.operators.filter(
            (item) => item.operId === Number(newItem.operId)
          );

          if (nameOperator.length > 0) {
            newItem.nombre = nameOperator[0].nombre;
          }

          if (!state.state.edit.firmas) {
            const updatedEdit = {
              ...state.state.edit,
              firmas: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              firmas: [...state.state.edit.firmas, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteFirm(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteFirmToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.firmas;

              options = options.filter((option) => {
                return option.operId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.firmas = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editFirm(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editFirmToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.firmas;
              options = options.map((option) => {
                if (option.operId !== item.operId) {
                  return option;
                }
                item = {
                  nombre: item.name,
                  operId: item.operId,
                  orden: item.order,
                };

                return item;
              });

              let edit = { ...state.state.edit };
              edit.firmas = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //reglas pre liquidación
    async addRulePreLiquidation(state) {
      try {
        const response =
          await state.state.service.addRulePreLiquidationToLiquidation(
            state.state.new
          );
        const newItem = response.data;

        const updatedEdit = {
          ...state.state.edit,
          reglasPreLiq: [...state.state.edit.reglasPreLiq, newItem],
        };

        state.commit("setEdit", updatedEdit);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteRulePreLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRulePreLiquidationToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.reglasPreLiq;

              options = options.filter((option) => {
                return option.id !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.reglasPreLiq = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editRulePreLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editRulePreLiquidationLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.reglasPreLiq;
              options = options.map((option) => {
                if (option.id !== item.id) {
                  return option;
                }

                return item;
              });

              let edit = { ...state.state.edit };
              edit.reglasPreLiq = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //reglas de liquidación

    async addRuleLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response =
            await state.state.service.addRuleLiquidationToLiquidation(
              state.state.new
            );
          const newItem = response.data;

          const nameRuleLiquidation =
            rulesLiquidations.state.rulesLiquidations.filter(
              (item) => item.id === newItem.reglaLiqId
            );

          if (nameRuleLiquidation.length > 0) {
            newItem.nombre = nameRuleLiquidation[0].name;
          }

          if (!state.state.edit.reglasLiq) {
            const updatedEdit = {
              ...state.state.edit,
              reglasLiq: [newItem],
            };

            state.commit("setEdit", updatedEdit);
          } else {
            const updatedEdit = {
              ...state.state.edit,
              reglasLiq: [...state.state.edit.reglasLiq, newItem],
            };

            state.commit("setEdit", updatedEdit);
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteRuleLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRuleLiquidationToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.reglasLiq;

              options = options.filter((option) => {
                return option.reglaLiqId !== state.state.itemDelete.id;
              });

              let edit = { ...state.state.edit };
              edit.reglasLiq = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editRuleLiquidation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editRuleLiquidationToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.reglasLiq;
              options = options.map((option) => {
                if (option.id !== item.id) {
                  return option;
                }

                return item;
              });

              let edit = { ...state.state.edit };
              edit.reglasLiq = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    //reglas de ajuste

    async addRuleAdjustment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response =
            await state.state.service.addRuleAdjustmentToLiquidation(
              state.state.new
            );
          const newItem = response.data;

          if (!state.state.edit.reglasAjuste) {
            state.state.edit.reglasAjuste = [];
          }

          const updatedEdit = {
            ...state.state.edit,
            reglasAjuste: [...state.state.edit.reglasAjuste, newItem],
          };

          state.commit("setEdit", updatedEdit);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteRuleAdjustment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRuleAdjustmentToLiquidation(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.reglasAjuste;

              let item = state.state.itemDelete;
              options = options.filter((option) => {
                return option.orden !== item.order;
              });

              let edit = { ...state.state.edit };
              edit.reglasAjuste = options;

              state.commit("setEdit", edit);

              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async editRuleAdjustment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editRuleAdjustmentToLiquidation(state.state.editRelation)
            .then(() => {
              let item = state.state.editRelation;
              let options = state.state.edit.reglasAjuste;

              options = options.map((option) => {
                if (option.orden !== item.orderOld) {
                  return option;
                }
                item = {
                  activa: item.itemsForm.activa,
                  nomProc: item.itemsForm.nameProcedure,
                  descrip: item.itemsForm.description,
                  orden: item.itemsForm.order,
                };

                return item;
              });

              let edit = { ...state.state.edit };
              edit.reglasAjuste = options;

              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    // AUDITORIA
    async addAudit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.addAudit(state.state.newAudit);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async deleteAudit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteAudit(state.state.itemDelete)
            .then(() => {
              let options = state.state.edit.audit.filter((option) => {
                return option.tabla != state.state.itemDelete.tabla;
              });
              let edit = { ...state.state.edit };
              edit.audit = options;
              state.commit("setEdit", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editAuditItem(state) {
      try {
        const item = state.state.editRelation;
        await state.state.service.editAudit(item);
        const updatedAuditItem = {
          dateStart: item.hasOwnProperty("fecDesdeNew")
            ? moment(item.fecDesdeNew, "YYYY-MM-DD").format("DD-MM-YYYY")
            : moment(item.dateStart, "YYYY-MM-DD").format("DD-MM-YYYY"),
          dateEnd: item.hasOwnProperty("haNoEx")
            ? ""
            : item.hasOwnProperty("fecHastaNew")
            ? moment(item.fecHastaNew, "YYYY-MM-DD").format("DD-MM-YYYY")
            : moment(item.dateEnd, "YYYY-MM-DD").format("DD-MM-YYYY"),
          tabla: item.tabla,
          operId: item.operId,
        };
        const updatedAudit = state.state.edit.audit.map((option) => {
          return option.tabla !== item.tabla ? option : updatedAuditItem;
        });

        const updatedEdit = { ...state.state.edit };
        updatedEdit.audit = updatedAudit;

        state.commit("setEdit", updatedEdit);
        return true;
      } catch (error) {
        throw error;
      }
    },
    async getGeneratePassword(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getGeneratePassword();
          resolve(item);
        } catch (error) {
          reject(error);
        }
      });
    },
    changepass(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.changepass(
            state.state.idOper,
            state.state.pass,
            state.state.sendMail
          );
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
